module.exports = __webpack_public_path__ + "img/seal.b939c31.svg";